var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h2',[_vm._v("計算一覧")]),_c('p',[_c('router-link',{attrs:{"to":"/tapioka"}},[_vm._v("タピオカ")])],1),_c('router-link',{attrs:{"to":"/Deviation"}},[_vm._v("偏差値の計算")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }